import styled from "@emotion/styled";
import theme from "../../styles/theme";
import { Link } from "gatsby";
import CTA from "../cta/cta";

export const FooterBackground = styled.footer`
  padding: ${theme.spacing[8]} 0;
  font-size: ${theme.fontSizes[2]};
  background-color: ${theme.colors.darkBlues[100]};

  color: ${theme.colors.darkBlues[10]};

  h6 {
    color: ${theme.colors.darkBlues[50]};
  }

  a {
    color: ${theme.colors.darkBlues[10]};

    &:hover {
      color: ${theme.colors.darkBlues[5]};
    }
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      margin-bottom: ${theme.spacing[2]};
    }
  }

  .two-column-list {
    ul {
      display: inline-block;
      column-count: 2;
      column-gap: ${theme.spacing[8]};
    }
  }

  hr {
    border-color: ${theme.colors.darkBlues[75]};
    margin: ${theme.spacing[4]} 0;
  }
`;

export const FooterColumns = styled.div`
  margin-bottom: ${theme.spacing[4]};

  ${theme.largerThan.md} {
    margin-bottom: ${theme.spacing[8]};
  }
`;

export const FooterColumn = styled.div`
  margin-bottom: ${theme.spacing[4]};

  ${theme.largerThan.md} {
    margin-bottom: ${theme.spacing[8]};
  }
`;

export const FooterRowLinks = styled.ul`
  font-size: ${theme.fontSizes[1]};
  color: ${theme.colors.darkBlues[50]};

  p {
    a {
      color: ${theme.colors.darkBlues[50]};
    }
  }
`;

export const FooterRowBottom = styled.div`
  font-size: ${theme.fontSizes[1]};
  color: ${theme.colors.darkBlues[50]};

  a {
    color: ${theme.colors.darkBlues[50]};
  }
`;

export const FooterRowBottomLeftLink = styled.div`
  color: ${theme.colors.darkBlues[50]};
  font-size: ${theme.fontSizes[1]};

  p {
    a {
      color: ${theme.colors.darkBlues[50]};
    }
  }

  ${theme.smallerThan.md} {
    p {
      margin: ${theme.spacing[4]} 0;
    }
  }

  ${theme.largerThan.md} {
    display: flex;
    align-items: center;
    gap: ${theme.spacing[2]};
  }
`;

export const FooterRowBottomRightLink = styled.div`
  display: flex;
  align-items: center;

  ${theme.largerThan.lg} {
    justify-content: flex-end;
  }

  a {
    display: inline-block;
    color: ${theme.colors.darkBlues[50]} !important;
    margin: 0 ${theme.spacing[2]};

    &:hover {
      color: ${theme.colors.darkBlues[5]} !important;
    }

    i {
      font-size: ${theme.fontSizes[4]};
    }
  }
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
  display: none;

  ${theme.largerThan.lg} {
    display: block;
  }
`;

export const StyledLinkMobile = styled(Link)`
  display: inline-block;
  text-decoration: none;
  margin-bottom: ${theme.spacing[8]};

  ${theme.largerThan.lg} {
    display: none;
  }
`;

export const XometryLogoMark = styled.span`
  display: inline-block;
  background-repeat: no-repeat;
  background-position-y: center;
  width: 28.54px;
  height: 30px;
  background-image: url("/xometry-logo-mark.svg");
  background-size: 28.54px 30px;
  vertical-align: middle;
  margin-right: 5px;
`;
